// extracted by mini-css-extract-plugin
module.exports = {"pdf-layout-wrapper":"pdfLayout_pdf-layout-wrapper__q5zze"};